/**
 * Deep B: three brick-lined diamond veins, each with an expanding wall at its mouth. Dig in and
 * the wall follows you down the vein, so each vein is a one-way run (docs/spec/03 §3).
 */

import type { CaveDef } from '../types';

export const deepB: CaveDef = {
  id: 'B',
  name: 'CREEPERS',
  hint: 'The walls follow you. Run each vein once, grab and go.',
  intermission: false,
  colors: [5, 12, 1],
  diamondValue: 15,
  extraValue: 22,
  fill: { base: '.', items: [['r', 12], ['d', 3]] },
  levels: [
    { seed: 5201, diamonds: 14, time: 150 },
    { seed: 5202, diamonds: 17, time: 140 },
    { seed: 5203, diamonds: 20, time: 130 },
    { seed: 5204, diamonds: 23, time: 120 },
    { seed: 5205, diamonds: 26, time: 110 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
    'W.....?????????????????????????????????W',
    'W..P..?????????????????????????????????W',
    'W.....?????????????????????????????????W',
    'Ww.wwwwwdwwwwwdwwwwwdwwwwdwwww?????????W',
    'Wx..d..d.d..dd..d.d..d..dd.d.w?????????W',
    'Wwwwwwwwwwwwwwwwwwwwwwwwwwww.w?????????W',
    'W??????????????????????????...?????????W',
    'W???????????????????????????????????...W',
    'W?????????wwwwwdwwwwwdwwwwwdwwwwdwwww.wW',
    'W?????????w.d.dd..d.d..d..d.dd.d..d...xW',
    'W?????????w.wwwwwwwwwwwwwwwwwwwwwwwwwwwW',
    'W?????????...??????????????????????????W',
    'W...???????????????????????????????????W',
    'Ww.wwwwwdwwwwwdwwwwwdwwwwdwwww?????????W',
    'Wx...d.d..dd.d..d..d.dd..d.d.w?????????W',
    'Wwwwwwwwwwwwwwwwwwwwwwwwwwww.w?????????W',
    'W??????????????????????????...?????????W',
    'W??????????????????????????????????????W',
    'W?????????????????????????????????.....W',
    'W?????????????????????????????????...X.W',
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
  ],
};
